<template>
  <div class="context__form-container">
    <FormGroup
      small-label
      required
      :label="$t('fieldSocialHandleSubForm.platformLabel')"
      :helper-text="$t('fieldSocialHandleSubForm.platformHelp')"
      :error="fieldHasErrors('platform')"
    >
      <Dropdown
        v-model="v$.values.platform.$model"
        :error="fieldHasErrors('platform')"
        :fixed-items="true"
        :show-search="false"
        @hide="v$.values.platform.$touch"
      >
        <DropdownItem
          v-for="platform in platforms"
          :key="platform.value"
          :name="platform.name"
          :value="platform.value"
        ></DropdownItem>
      </Dropdown>
    </FormGroup>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import form from '@baserow/modules/core/mixins/form'
import fieldSubForm from '@baserow/modules/database/mixins/fieldSubForm'
import {
  DEFAULT_PLATFORM,
  PLATFORM_CHOICES,
} from '@baserow/modules/database/utils/socialHandle'

export default {
  name: 'FieldSocialHandleSubForm',
  mixins: [form, fieldSubForm],
  setup() {
    return { v$: useVuelidate({ $lazy: true }) }
  },
  data() {
    return {
      allowedValues: ['platform'],
      values: {
        platform: DEFAULT_PLATFORM,
      },
      platforms: PLATFORM_CHOICES,
    }
  },
  validations() {
    return {
      values: {
        platform: { required },
      },
    }
  },
}
</script>
